import React from "react";
import PlaceholderPage from "./PlaceholderPage";

/** Placeholder page for newsletter management, audience segmentation and performance tracking. */
const Newsletters: React.FC = () => (
	<PlaceholderPage title="Newsletters" description="Plan sends, segment audiences, and keep track of newsletter performance." />
);

export default Newsletters;

